export class MechanicStorage {
    public static currentMechanic;
}